import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from "react-router-dom";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Navigation from "./Navigation/navigation";
import DashboardPage from "./pages/DashboardPage";
import AdminDashboardPage from "./pages/AdminDashboardPage";
import AddRecordPage from "./pages/AddRecordPage";
import EditRecordPage from "./pages/EditRecordPage";
import EditRecordsPage from "./pages/EditDeleteRecordsPage";
import SearchPage from "./pages/SearchPage";
import LoginPage from "./pages/LoginPage";
import UserManagementPage from "./pages/UserManagementPage";

import UnauthorizedPage from "./pages/UnauthorizedPage";

// Component to conditionally render navigation
function AppContent() {
  const location = useLocation();
  const hideNavRoutes = ['/login', '/unauthorized'];
  const shouldHideNav = hideNavRoutes.includes(location.pathname);

  return (
    <div className="App">
      {!shouldHideNav && <Navigation />}
      <div className={!shouldHideNav ? "pt-16" : ""}>
        <Routes>
        {/* Public routes */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/unauthorized" element={<UnauthorizedPage />} />
        
        {/* Protected routes - User Dashboard */}
        <Route path="/" element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path="/dashboard" element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        
        {/* Admin Dashboard - separate page with full admin features */}
        <Route path="/admin-dashboard" element={
          <ProtectedRoute adminOnly={true}>
            <AdminDashboardPage />
          </ProtectedRoute>
        } />
        
        <Route path="/add-record" element={
          <ProtectedRoute>
            <AddRecordPage />
          </ProtectedRoute>
        } />
        <Route path="/edit-record/:recordId" element={
          <ProtectedRoute>
            <EditRecordPage />
          </ProtectedRoute>
        } />
        <Route path="/edit-records" element={
          <ProtectedRoute adminOnly={true}>
            <EditRecordsPage />
          </ProtectedRoute>
        } />
        <Route path="/search" element={
          <ProtectedRoute>
            <SearchPage />
          </ProtectedRoute>
        } />
        
        {/* Admin only routes */}
        <Route path="/admin" element={
          <ProtectedRoute adminOnly={true}>
            <UserManagementPage />
          </ProtectedRoute>
        } />
      </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
